/**
 * Builder dirty-state bridge. The "Back to reports" pill lives in the app-bar
 * header (ReportHeaderTitle), OUTSIDE the tree that hosts the builder — yet
 * clicking it deletes the ?custom/?report params and with them any unsaved
 * edits. Context can't span the two trees, so this is the same module-level
 * bridge pattern as the export snapshot: the builder publishes its dirty flag,
 * the header consults it before discarding.
 */
import { useSyncExternalStore } from "react";

let dirty = false;
const listeners = new Set<() => void>();

export function setBuilderDirty(next: boolean): void {
  if (dirty === next) return;
  dirty = next;
  listeners.forEach((fn) => fn());
}

function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** True while a mounted builder holds unsaved changes. */
export function useBuilderDirty(): boolean {
  return useSyncExternalStore(subscribe, () => dirty);
}
